import React from 'react';

import './_Button.scss';
import Button from '../Button';

import { ButtonProps } from '../Button';

export default function (props: ButtonProps) {
    return <Button {...props} />;
}
